module.exports = __webpack_public_path__ + "img/dw_1.9659523b.png";